<template>
    <a-card>
        <a-table
            :columns="columns"
            :pagination="pagination"
            :data-source="dataSource"
            :loading="loading"
            @change="onTableChange">
            <template #activityName="{record}">
                <a @click="onEdit(record)">{{record.activityName}}</a>
            </template>
        </a-table>
    </a-card>
    <Detail ref="modal" :form-primary-key-field="listKeyField" @finish="onFormEdited"/>
</template>

<script>
import Detail from "./components/Detail";
import {basicsActivityInfo} from "@/api/tenantService";
import {activityApi} from "@/api/innovationService";
import {tableListMixin} from "@/mixins";
import {defaultDateCustomRender} from "@/utils/customRender";

const columns = [
    // {title: "#", dataIndex: "index", key: "index", slots: {customRender: "index"}},
    {title: "活动名称", dataIndex: "activityName", key: "activityName", slots: {customRender: "activityName"}},
    // {title: "企业名称", dataIndex: "unitName", key: "unitName"},
    {title: "联系人", dataIndex: "name", key: "name"},
    {title: "联系电话", dataIndex: "phone", key: "phone"},
    {title: "预计报名人数", dataIndex: "applyNum", key: "applyNum"},
    {title: "报名时间", dataIndex: "createdTime", key: "createdTime", customRender: defaultDateCustomRender},
];
export default {
    name: "index",
    mixins: [tableListMixin],
    components: {
        Detail
    },
    data() {
        return {
            columns,
            queryParamFixed: {
                companyCode:this.$ls.get("companyCode"),
                systemType: 'innovation'
            },
            listKeyField: "id",
            listUrl:activityApi.pageList
        }
    },
    mounted() {
    },
    methods: {
        onEdit(record) {
            console.log(record)
            this.getAction({
                url: basicsActivityInfo.detail,
                params: {id: record.activityId}
            }).then(res => {
                this.onShowModal('modal', res);
            })
        },

    }
}
</script>

<style scoped>

</style>
